<nz-image-group>
  <swiper [config]="swiperConfig">
    <ng-template swiperSlide *ngFor="let image of images">
      <img nz-image [nzSrc]="image" referrerpolicy="no-referrer" (error)="imageLoadFailed()" />
    </ng-template>
  </swiper>
</nz-image-group>
